var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6688 26.2712V24.4077C26.6688 23.4192 26.2762 22.4712 25.5772 21.7723C24.8783 21.0733 23.9303 20.6807 22.9418 20.6807H15.4878C14.4993 20.6807 13.5513 21.0733 12.8524 21.7723C12.1534 22.4712 11.7607 23.4192 11.7607 24.4077V26.2712",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0285 16.954C21.0869 16.954 22.7556 15.2854 22.7556 13.227C22.7556 11.1686 21.0869 9.5 19.0285 9.5C16.9702 9.5 15.3015 11.1686 15.3015 13.227C15.3015 15.2854 16.9702 16.954 19.0285 16.954Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0002,
    cy: 18.9997,
    r: 16.4167,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98591 31.963L8.69302 31.2559L7.27881 29.8416L6.5717 30.5488L7.98591 31.963ZM2.70133 34.4191C2.31081 34.8097 2.31081 35.4428 2.70133 35.8333C3.09186 36.2239 3.72502 36.2239 4.11554 35.8333L2.70133 34.4191ZM6.5717 30.5488L2.70133 34.4191L4.11554 35.8333L7.98591 31.963L6.5717 30.5488Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search-2.dcccd6c1267f87257c1d3ab62a03f96a.svg";
export { ForwardRef as ReactComponent };